import { computed } from 'vue'
import store from '@/store/store'
import { QueueSDK, QueueCallSDK } from '@voicenter-team/events-sdk'

type QueueState = {
    queues: { all: Array<QueueSDK> }
}

// Module-level computeds: shared across all consumers instead of allocated
// per call. Lazy — only evaluate on first `.value` read.
const queues = computed<QueueSDK[]>(() => (store.state as QueueState)?.queues.all)

const queueWithActiveCalls = computed<QueueSDK[]>(() => {
    return store.getters['queues/queueWithActiveCalls'] || []
})

const allQueueCalls = computed<QueueCallSDK[]>(() => {
    return store.getters['queues/allQueueCalls'] || []
})

export default function useQueues () {
    return {
        queues,
        queueWithActiveCalls,
        allQueueCalls,
    }
}
